import { PlaceholderPage } from '../components/PlaceholderPage';

export const Privacy = () => {
  return (
    <PlaceholderPage
      title="Privacy Policy"
      description="How we handle the personal information you share with WineryXplorer."
    />
  );
};
